<template>
    <svg
        id="File_PDF"
        data-name="File PDF"
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="21"
        viewBox="0 0 16.619 20.61"
    >
        <path
            id="Pfad_369"
            data-name="Pfad 369"
            d="M34.35,20.61h-13.9a1.322,1.322,0,0,1-1.36-1.277V1.278A1.322,1.322,0,0,1,20.451,0H28.7a.826.826,0,0,1,.579.234l6.209,6.152a.727.727,0,0,1,.219.516V19.333a1.322,1.322,0,0,1-1.36,1.277m-13.663-1.5H34.114V7.2L28.36,1.5H20.687Z"
            transform="translate(-19.091)"
            fill="#D0A97E"
        />
        <path
            id="Pfad_370"
            data-name="Pfad 370"
            d="M34.391,7.832h-5.7a1.45,1.45,0,0,1-1.486-1.407V.75h1.6V6.332h5.589Z"
            transform="translate(-18.571)"
            fill="#D0A97E"
        />
        <path
            id="Pfad_371"
            data-name="Pfad 371"
            d="M27.2,13.651H25.991V16.19H24.9V9.933h2.3c1.58,0,2.356.846,2.356,1.864,0,.891-.622,1.854-2.356,1.854m0-.837c.852,0,1.235-.387,1.235-1.017,0-.649-.383-1.026-1.235-1.026H25.991v2.043Z"
            transform="translate(-18.719)"
            fill="#D0A97E"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "FilePdfIcon",
    props: {},
});
</script>
